// Umami is self-hosted on the Antomic cluster, like the other Antomic sites.
const UMAMI_SCRIPT_URL = 'https://um.prod.antomic.net/script.js'
const UMAMI_WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID
// Only the production site counts: previews on pages.dev, localhost and the iOS shell do not.
const UMAMI_DOMAINS = 'justdecideapp.com,www.justdecideapp.com'

type EventData = Record<string, string | number>

declare global {
  interface Window {
    umami?: { track(event: string, data?: EventData): void }
  }
}

export function initAnalytics(): void {
  if (!UMAMI_WEBSITE_ID) {
    return
  }

  const script = document.createElement('script')
  script.defer = true
  script.src = UMAMI_SCRIPT_URL
  script.dataset.websiteId = UMAMI_WEBSITE_ID
  script.dataset.domains = UMAMI_DOMAINS
  document.head.appendChild(script)
}

// Umami counts page views itself. An event sent before its script has loaded is
// dropped by Umami, which only affects events fired on the first render.
export function track(event: string, data?: EventData): void {
  window.umami?.track(event, data)
}
